import config from "../../config/config";
import * as mocks from "./levelTestGroups.mocks";
import { CreateLevelTestGroupInput, LevelTestGroup, UpdateLevelTestGroupInput, LevelTestGroupListResponse } from "./levelTestGroups.interfaces";
import * as api from "./levelTestGroups.api";

export const getLevelTestGroups = async (filters?: {
  level?: number;
  search?: string;
  page?: number;
  limit?: number;
}): Promise<LevelTestGroupListResponse> => {
  return await (config.useRealApi ? api.apiGetLevelTestGroups(filters) : mocks.getLevelTestGroups(filters));
};

// Versão adaptada para InfiniteScroll que retorna apenas os itens
export const getLevelTestGroupsForInfiniteScroll = async (page: number, filters?: {
  level?: number;
  search?: string;
}): Promise<LevelTestGroup[]> => {
  const response = await getLevelTestGroups({
    ...filters,
    page,
    limit: 20
  });
  
  // Retorna array vazio se não há mais itens (para parar o infinite scroll)
  const items = response.items || response.data || [];
  return items;
};

export const getLevelTestGroup = async (id: string): Promise<LevelTestGroup> => {
  return await (config.useRealApi ? api.apiGetLevelTestGroup(id) : mocks.getLevelTestGroup(id));
};

export const createLevelTestGroup = async (data: CreateLevelTestGroupInput): Promise<string> => {
  return await (config.useRealApi ? api.apiCreateLevelTestGroup(data) : mocks.createLevelTestGroup(data));
};

export const updateLevelTestGroup = async (id: string, data: UpdateLevelTestGroupInput): Promise<void> => {
  return await (config.useRealApi ? api.apiUpdateLevelTestGroup(id, data) : mocks.updateLevelTestGroup(id, data));
};

export const deleteLevelTestGroup = async (id: string): Promise<void> => {
  return await (config.useRealApi ? api.apiDeleteLevelTestGroup(id) : mocks.deleteLevelTestGroup(id));
};
